<template>
  <div>
    <div class="blackLayerbg" v-show="shade"></div>
    <div class="openAccount" v-show="display">
      <div class="closeIcon">
        <a href="javascript:;" v-on:click="close()"></a>
      </div>
      <b>开通高级账号查询更多内容</b>
      <ul>
        <li>
          <input type="text" placeholder="姓名" v-model="userinfo.name" />
          <span style="font-size: 10px; color: red">{{ error.name }}</span>
        </li>
        <li>
          <input type="text" placeholder="公司" v-model="userinfo.company" />
          <span style="font-size: 10px; color: red">{{ error.company }}</span>
        </li>
        <li>
          <input type="text" placeholder="部门" v-model="userinfo.department" />
          <span style="font-size: 10px; color: red">{{
            error.department
          }}</span>
        </li>
        <li>
          <input type="text" placeholder="职位" v-model="userinfo.jobTitle" />
          <span style="font-size: 10px; color: red">{{ error.jobTitle }}</span>
        </li>
        <li>
          <input type="text" placeholder="手机" v-model="userinfo.mobile" />
          <span style="font-size: 10px; color: red">{{ error.mobile }}</span>
        </li>
        <li>
          <input type="text" placeholder="邮箱" v-model="userinfo.email" />
          <span style="font-size: 10px; color: red">{{ error.email }}</span>
        </li>
      </ul>
      <div class="emailTips" v-show="is_email_error">
        <em>请输入公司邮箱</em>
        <a
          class="emailinfoaa"
          href="javascript:;"
          v-on:click="is_email_error_info = true"
          v-show="!is_email_error_info"
          >详情 &gt;</a
        >
        <p class="emailinfopp" v-show="is_email_error_info">
          如有疑问请发邮件至<a href="mailto:data-group@gasgoo.com"
            >data-group@gasgoo.com</a
          >邮箱垂询
        </p>
      </div>
      <p>客服电话：021-39586681</p>
      <a href="javascript:;" v-on:click="submit()" class="uploadBut"
        >提交申请</a
      >
    </div>
    <div class="submitLayer" v-show="is_success">
      <div class="closeIcon">
        <a href="javascript:;" v-on:click="is_success = false"></a>
      </div>
      <em></em>
      <p>提交成功</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "inquiry",
  props: {
    display: Boolean,
    user_id: Number,
  },
  data() {
    return {
      is_success: false,
      shade: false,
      is_email_error: false,
      is_email_error_info: false,
      userinfo: {
        userId: 0,
        name: "",
        company: "",
        department: "",
        jobTitle: "",
        mobile: "",
        email: "",
      },
      error: {
        name: "",
        company: "",
        department: "",
        jobTitle: "",
        mobile: "",
        email: "",
      },
    };
  },
  watch: {
    display: function (val) {
      if (val) {
        this.init();
      }

      if (val && !this.shade) {
        this.shade = true;
        this.is_email_error = false;
        this.is_email_error_info = false;
      }
    },
  },
  methods: {
    submit() {
      let _this = this;
      this.error.name =
        this.error.company =
        this.error.department =
        this.error.jobTitle =
        this.error.mobile =
        this.error.email =
          "";
      if (this.userinfo.name === "") {
        this.error.name = "请输入姓名";
        return;
      }
      if (this.userinfo.company === "") {
        this.error.company = "请输入公司";
        return;
      }
      if (this.userinfo.department === "") {
        this.error.department = "请输入部门";
        return;
      }
      if (this.userinfo.jobTitle === "") {
        this.error.jobTitle = "请输入职位";
        return;
      }
      if (this.userinfo.mobile === "") {
        this.error.mobile = "请输入手机号";
        return;
      }
      if (this.userinfo.email === "") {
        this.is_email_error = false;
        this.error.email = "请输入邮箱";
        return;
      }

      this.$http({
        method: "POST",
        url: "/home/emailcheck",
        params: {
          email: this.userinfo.email,
        },
      })
        .then(function (result) {
          if (!result.data) {
            _this.error.email = "";
            _this.is_email_error = true;
            return;
          }

          _this.userinfo.userId = Number(_this.user_id);
          _this.$http({
            method: "POST",
            url: "/home/inquiry",
            params: _this.userinfo,
          })
            .then(function () {
              _this.$emit("hide");
              _this.is_success = true;
              _this.display = false;
              setTimeout(function () {
                _this.is_success = false;
                _this.shade = false;
              }, 1500);
            })
            .catch(function (error) {
              console.log(error); //失败
            });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    init: function () {
      let _this = this;
      this.$http({
        url: "/home/inquiry",
        method: "get",
        crossdomain: true,
        params: {
          userId: _this.user_id,
        },
      })
        .then(function (res) {
          _this.userinfo.name = res.data.name;
          _this.userinfo.company = res.data.company;
          _this.userinfo.department = res.data.department;
          _this.userinfo.jobTitle = res.data.jobTitle;
          _this.userinfo.mobile = res.data.mobile;
          _this.userinfo.email = res.data.email;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    close: function () {
      this.shade = false;
      this.display = false;
    },
  },
};
</script>
